module.exports = __webpack_public_path__ + "img/banner-pixel.2d0f04c4.jpg";